namespace Area {

    function Area(searchUnitService,
                  basketService) {
        return {
            'hotels': {
                name: 'hotels',
                mode: searchUnitService.hotel,
                flow: basketService.hotelBooking,
                searchMsg: 'SEARCHINGHOTELS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Hotels,
                timeSupport: false,
            },
            'transfers': {
                name: 'transfers',
                mode: searchUnitService.transfer,
                flow: basketService.transferBooking,
                searchMsg: 'SEARCHINGTRANSFERS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Transfers,
                timeSupport: true,
            },
            'holidays': {
                name: 'holidays',
                mode: searchUnitService.flight,
                flow: basketService.holidayBooking,
                searchMsg: 'SEARCHINGFLIGHTSANDHOTELS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.FlightsAndHolidays,
                timeSupport: false,
            },
            'flights': {
                name: 'flights',
                mode: searchUnitService.flight,
                flow: basketService.flightBooking,
                searchMsg: 'SEARCHINGFLIGHTS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.FlightsAndHolidays,
                timeSupport: false,
            },
            'marhaba': {
                name: 'marhaba',
                mode: searchUnitService.marhaba,
                flow: basketService.marhabaBooking,
                searchMsg: 'SEARCHINGMARHABA',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Marhaba,
                timeSupport: true,
            },
            'emirates': {
                name: 'emirates',
                mode: searchUnitService.hotel,
                flow: basketService.hotelBooking,
                searchMsg: 'SEARCHINGHOTELS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Hotels,
                timeSupport: false,
            },
            'parking' : {
                name: 'parking',
                mode: searchUnitService.parking,
                flow: basketService.parkingBooking,
                searchMsg: 'SEARCHINGPARKING',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Parking,
                timeSupport: true,
            },
            'attractions' : {
                name: 'attractions',
                mode: searchUnitService.attractions,
                flow: basketService.attractionsBooking,
                searchMsg: 'SEARCHINGATTRACTIONS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Attractions,
                timeSupport: false,
            },
            'insurance': {
                name: 'insurance',
                mode: searchUnitService.insurance,
                flow: basketService.insuranceBooking,
                searchMsg: 'SEARCHINGINSURANCE',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Insurance,
                timeSupport: false,
            }
        };
    }

    angular
        .module('TR')
        .factory('Area', Area);
}
